import { z } from "zod";
export const MARKDOWN_TEXT_LIMITS = {
    titleCharacters: 255,
    markdownCharacters: 50_000,
};
export const MarkdownTextParamsSchema = z
    .object({
    schemaVersion: z.literal(1),
    title: z.string().max(MARKDOWN_TEXT_LIMITS.titleCharacters),
    markdown: z.string().max(MARKDOWN_TEXT_LIMITS.markdownCharacters),
})
    .strict();
export const defaultMarkdownTextParams = {
    schemaVersion: 1,
    title: "Notes",
    markdown: "",
};
//# sourceMappingURL=markdownText.js.map